import { cn } from '@/lib/utils'

const RATIOS = {
  '4/1': {
    mobile: 'aspect-[4/1]',
    desktop: 'lg:aspect-[4/1]',
  },
  '2/1': {
    mobile: 'aspect-[2/1]',
    desktop: 'lg:aspect-[2/1]',
  },
  '4/3': {
    mobile: 'aspect-[4/3]',
    desktop: 'lg:aspect-[4/3]',
  },
  '1/1': {
    mobile: 'aspect-[1/1]',
    desktop: 'lg:aspect-[1/1]',
  },
  '4/5': {
    mobile: 'aspect-[4/5]',
    desktop: 'lg:aspect-[4/5]',
  },
  '5/4': {
    mobile: 'aspect-[5/4]',
    desktop: 'lg:aspect-[5/4]',
  },
  '2/3': {
    mobile: 'aspect-[2/3]',
    desktop: 'lg:aspect-[2/3]',
  },
  '3/4': {
    mobile: 'aspect-[3/4]',
    desktop: 'lg:aspect-[3/4]',
  },
}

export type Ratio = '4/1' | '2/1' | '4/3' | '1/1' | '4/5' | '2/3' | '3/4' | '5/4'

type AspectRatioProps = {
  ratio?: Ratio
  ratios?: {
    mobile: Ratio
    desktop: Ratio
  }
  children: React.ReactNode
}

const getAspectRatios = (ratio?: Ratio, ratios?: { desktop: Ratio; mobile: Ratio }) => {
  if (ratios) {
    return `${RATIOS[ratios.mobile].mobile} ${RATIOS[ratios.desktop].desktop}`
  }

  if (!ratio) return RATIOS['2/1'].mobile

  return RATIOS[ratio].mobile
}

export const AspectRatio = ({ ratio, ratios, children }: AspectRatioProps) => {
  const aspectRatios = getAspectRatios(ratio, ratios)

  return (
    // <div className="w-full bg-grey-100">
    <div className={cn('relative w-full', aspectRatios)}>{children}</div>
    // </div>
  )
}
